<template>
    <v-dialog :value="value" max-width="500px" @click:outside="close">
        <v-card>
            <v-toolbar>
                <v-toolbar-title>Send SMS</v-toolbar-title>
            </v-toolbar>

            <div>
                <v-card-text>
                    <SmsRecipientSelect :customer-id="customerId" :car-id="carId"
                                        v-model="recipient"></SmsRecipientSelect>
                    <v-textarea outlined label="Din melding" counter="160" v-model="smsText" class="mt-4"
                                ref="messageText"></v-textarea>
                </v-card-text>
                <v-card-actions>
                    <v-btn color="red" text @click="close">
                        <v-icon left>close</v-icon>
                        Lukk
                    </v-btn>
                    <v-spacer/>
                    <v-btn color="green" text @click="send" :loading="saving">
                        <v-icon left>send</v-icon>
                        Send SMS
                    </v-btn>
                </v-card-actions>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
import CustomerSearch from './CustomerSearch';
import SmsRecipientSelect from "@/components/helpers/SmsRecipientSelect";

export default {
    components: {
        CustomerSearch,
        SmsRecipientSelect
    },

    props: {
        value: {
            type: Boolean,
            default: false
        },
        customerId: {
            type: Number,
            required: false
        },
        carId: {
            type: Number,
            required: false
        }
    },

    data() {
        return {
            saving: false,
            recipient: null,
            smsText: ''
        }
    },

    created() {
        this.loadData();
    },

    mounted() {
        setTimeout(() => {
            let textarea = this.$refs['messageText'].$refs['input'];
            textarea.focus();
            textarea.setSelectionRange(0, 0);
        });
    },

    methods: {
        loadData() {
        },
        close() {
            this.$emit('input', false);
        },
        send() {
            this.saving = true;
            this.$http.post(`sms`, {
                ...this.recipient,
                text: this.smsText
            }).then(response => {
                this.$emit('create', response.data.data.id);
                this.$emit('input', false);
                this.$root.addMessage('Meldingen ble sendt.', 'success');
            }).finally(() => {
                this.saving = false;
            });
        }
    },

    watch: {
        recipient() {
            let prefix = '';
            if (this.recipient.text) {
                if (this.recipient.car_id) {
                    prefix = `Din bil ${this.recipient.text} `;
                } else {
                    prefix = `${this.recipient.text} `;
                }
            }
            this.smsText = `${prefix}\n\n${this.$root.settings.sms_footer}`
        }
    }
}
</script>
